export const IssueTypeActionTypes = {
    API_RESPONSE_SUCCESS: '@@issueType/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@issueType/API_RESPONSE_ERROR',
    GET_ISSUE_TYPE_LIST: '@@issueType/GET_ISSUE_TYPE_LIST',
    GET_ISSUE_TYPE_ID: '@@issueType/GET_ISSUE_TYPE_ID',
    ADD_ISSUE_TYPE: '@@issueType/ADD_ISSUE_TYPE',
    ADD_ISSUE_TYPE_INSTANT: '@@issueType/ADD_ISSUE_TYPE_INSTANT',
    UPDATE_ISSUE_TYPE: '@@issueType/UPDATE_ISSUE_TYPE',
    DELETE_ISSUE_TYPE: '@@issueType/DELETE_ISSUE_TYPE',
    RESET_ISSUE_TYPE_UPDATE: '@@issueType/RESET_ISSUE_TYPE_UPDATE',
    RESET_ISSUE_TYPE: '@@issueType/RESET_ISSUE_TYPE'
};